import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_HEADERS } from '@improver/core';
import { LoggedUserService } from '@improver/infrastructure/auth-data-layer';
import { Observable } from 'rxjs';
import { isInstanceRequest } from './interceptors.utils';

@Injectable()
export class UserInterceptor implements HttpInterceptor {
  constructor(private loggedUserService: LoggedUserService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return isInstanceRequest(request.url) ? next.handle(this.setUserId(request)) : next.handle(this.removeUserIdHeader(request));
  }

  private setUserId(request: HttpRequest<any>): HttpRequest<any> {
    const { userId } = this.loggedUserService.getUserDataForRequest();

    if (userId) {
      return request.clone({
        setHeaders: {
          [HTTP_HEADERS.USER_ID]: userId,
        },
      });
    }

    return request;
  }

  private removeUserIdHeader(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({ headers: request.headers.delete(HTTP_HEADERS.USER_ID) });
  }
}
